module.exports = __webpack_public_path__ + "img/go_open.968f52d3.png";